import React, { FC, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faAngleDoubleDown,
    faAngleDoubleUp,
    faChevronDown,
    faChevronUp,
    faPlus
} from "@fortawesome/free-solid-svg-icons";
import {
    VariationCollapseState,
    VariationViewType
} from "../../../models/common";
import { Button, Card, Collapse, Container } from "react-bootstrap";
import { Revision } from "../../../models/types";
import {
    getVariationCollapseState,
    saveVariationCollapseState
} from "../../../common/Helpers";
import { Variations } from "./Variations";

interface Props {
    revision: Revision;
    openNewItemModal: (type: VariationViewType) => void;
}

const VariationsManagerImplementation: FC<Props> = ({
    revision,
    openNewItemModal
}) => {
    const [showVariations, setShowVariations] = useState(
        getVariationCollapseState(VariationCollapseState.Variations)
    );
    const [showVariationsDetails, setShowVariationsDetails] = useState(
        getVariationCollapseState(VariationCollapseState.VariationDetails)
    );

    const updateShowVariations = (newState: boolean) => {
        saveVariationCollapseState(VariationCollapseState.Variations, newState);
        setShowVariations(newState);
    };

    const updateShowVariationDetails = (newState: boolean) => {
        saveVariationCollapseState(
            VariationCollapseState.VariationDetails,
            newState
        );
        setShowVariationsDetails(newState);
    };
    const hasVariations =
        revision.buildData &&
        Array.isArray(revision.buildData.variations) &&
        revision.buildData.variations.length > 0;

    return (
        <>
            <Container className="mb-4 p-0">
                <Card>
                    <Card.Header className="d-flex align-items-center">
                        <h5 className="text-inverse-50 mb-1 me-2">
                            Variations
                        </h5>
                        {hasVariations && (
                            <div
                                onClick={() => {
                                    updateShowVariations(!showVariations);
                                }}
                                data-toggle="tooltip"
                                title="Toggle Variations visibility"
                                className="ms-1 mb-1 text-inverse-50 mouseHover"
                            >
                                <FontAwesomeIcon
                                    icon={
                                        showVariations
                                            ? faChevronUp
                                            : faChevronDown
                                    }
                                />
                            </div>
                        )}
                        <div className="float-end ms-auto">
                            <Button
                                onClick={() =>
                                    openNewItemModal(
                                        VariationViewType.Variations
                                    )
                                }
                                className="btn-sm me-2"
                                data-toggle="tooltip"
                                title="Add new Variation"
                            >
                                <FontAwesomeIcon icon={faPlus} size="lg" />
                            </Button>

                            <Button
                                onClick={() => {
                                    updateShowVariationDetails(
                                        !showVariationsDetails
                                    );
                                }}
                                data-toggle="tooltip"
                                title={
                                    showVariationsDetails
                                        ? "Hide all Variations details"
                                        : "Show all Variations details"
                                }
                                className="btn-sm"
                                disabled={!hasVariations || !showVariations}
                            >
                                <FontAwesomeIcon
                                    size="lg"
                                    icon={
                                        showVariationsDetails
                                            ? faAngleDoubleUp
                                            : faAngleDoubleDown
                                    }
                                />
                            </Button>
                        </div>
                    </Card.Header>
                    {hasVariations && (
                        <Collapse in={showVariations}>
                            <div>
                                <Card.Body className="p-3">
                                    <Variations
                                        revision={revision}
                                        shouldBeVisible={showVariationsDetails}
                                    />
                                </Card.Body>
                            </div>
                        </Collapse>
                    )}
                </Card>
            </Container>
        </>
    );
};

export const VariationsManager = React.memo(VariationsManagerImplementation);
